import {
  LayoutDashboard, Users, UserCog, Building2, Pill, HeartHandshake, Activity,
  Truck, Wallet, GraduationCap, Boxes, Wrench, ShieldCheck, BarChart3, Bell,
  CheckSquare, Calendar, MessageSquare, FileText, Sparkles, Settings, AlertTriangle,
  HeartPulse, Megaphone,
} from "lucide-react";

// live = fully functional module in this build; roadmap = phased placeholder
export const NAV_GROUPS = [
  {
    label: "Overview",
    items: [
      { to: "/", label: "Command Center", icon: LayoutDashboard, live: true },
      { to: "/ai-insights", label: "AI Insights", icon: Sparkles, live: true, ai: true },
    ],
  },
  {
    label: "Care",
    items: [
      { to: "/residents", label: "Residents", icon: Users, live: true },
      { to: "/health", label: "Health Intelligence", icon: HeartPulse, live: true },
      { to: "/medications", label: "Medications", icon: Pill, live: true },
      { to: "/incidents", label: "Incidents", icon: AlertTriangle, live: true },
      { to: "/activities", label: "Activities", icon: Activity, live: true },
      { to: "/families", label: "Families", icon: HeartHandshake, live: true },
    ],
  },
  {
    label: "Workforce",
    items: [
      { to: "/staff", label: "Staff", icon: UserCog, live: true },
      { to: "/staffing", label: "Smart Staffing", icon: Calendar, live: true },
      { to: "/training", label: "Training", icon: GraduationCap, live: true },
      { to: "/programs", label: "Programs & Facilities", icon: Building2, live: true },
    ],
  },
  {
    label: "Governance",
    items: [
      { to: "/compliance", label: "Compliance", icon: ShieldCheck, live: true },
      { to: "/insightbridge", label: "InsightBridge 360", icon: Megaphone, live: true },
      { to: "/reports", label: "Reports & Analytics", icon: BarChart3, live: true },
      { to: "/documents", label: "Documents", icon: FileText, live: true },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/fleet", label: "Fleet", icon: Truck, live: true },
      { to: "/finance", label: "Finance", icon: Wallet, live: true },
      { to: "/assets", label: "Assets", icon: Boxes, live: true },
      { to: "/maintenance", label: "Maintenance", icon: Wrench, live: true },
    ],
  },
  {
    label: "Workspace",
    items: [
      { to: "/alerts", label: "Alerts", icon: Bell, live: true },
      { to: "/tasks", label: "Tasks", icon: CheckSquare, live: true },
      { to: "/messages", label: "Messages", icon: MessageSquare, live: true },
      { to: "/settings", label: "Settings", icon: Settings, live: true },
    ],
  },
];
